import { createLogger } from '../../../utils/logger';
export const logger = createLogger('kpi-utils');
export const TEST_IDS = {
    VERSUS: 'kpi_versus',
    DIFF_LABEL: 'kpi_comparision_diff_label',
    COMPARISON_TIME_BUCKET: 'kpi_comparision_time_bucket',
    COMPARISON: 'kpi_comparision',
    EMPTY_COMPARISON: 'kpi_comparision_empty',
    SUBLABEL: 'kpi_sublabel',
    KPI: 'chartviz_kpi',
    HERODATA: 'kpi_herodata',
    SPARKLINE: 'kpi_sparkline',
    INFO_ICON: 'kpi-info-icon',
    POPOVER_INFO: 'popover-info',
    METRIC: 'metric',
    EXPLAIN_CHANGE_ICON: 'explain-change-icon',
    BASE_VALUE: 'kpi_comparison_base_value',
    DIFF: 'kpi_comparision_diff',
    ANALYZE_BUTTON: 'kpi_analyze_button',
    CCA_ERROR_MODAL: 'kpi_cca_error_modal',
    CCA_ERROR_MODAL_DESCRIPTION: 'kpi_cca_error_modal_description',
};
//# sourceMappingURL=constants.js.map